import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section style={{background: 'linear-gradient(135deg, var(--primary-dark) 0%, var(--secondary-brown) 100%)', color: 'var(--white)'}}>
      <div className="container text-center">
        <h2 style={{color: 'var(--white)', marginBottom: '1rem'}}>{t('cta_heading')}</h2>
        <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.1rem', marginBottom: '2rem'}}>{t('cta_subtitle')}</p>
        <Link to="/franchise" className="btn btn-secondary">{t('cta_button')}</Link>
      </div>
    </section>
  );
};

export default CTA;